module.exports = __webpack_public_path__ + "img/hr-straight-rail-vertical-stone-path-background.9d1d1aae.png";